import { useHookstate } from "@hookstate/core";
import { useCallback } from "react";
import { useIsSidebarOpen } from "../../../../hooks/useIsSidebarOpen";
import { readerComponentsStore } from "../../../../hookstate/readerComponentStore";

export function useIsOverlayOpen() {
  const { isSidebarOpen, setIsSidebarOpen } = useIsSidebarOpen();
  const isOverlayOpen = useHookstate(readerComponentsStore.isOverlayOpen).get({
    noproxy: true,
  });

  const toggleIsOverlayOpen = useCallback(() => {
    const newOverlayState = !isOverlayOpen;
    // When opening overlay, ensure sidebar is closed
    if (newOverlayState) {
      setIsSidebarOpen(false);
    }
    // When closing overlay with sidebar open, close sidebar first
    else if (isSidebarOpen) {
      setIsSidebarOpen(false);
      return;
    }
    readerComponentsStore.isOverlayOpen.set(newOverlayState);
  }, [isOverlayOpen, isSidebarOpen, setIsSidebarOpen]);

  const setIsOverlayOpen = useCallback((value: boolean) => {
    // Always close sidebar when changing overlay state
    setIsSidebarOpen(false);
    readerComponentsStore.isOverlayOpen.set(value);
  }, [setIsSidebarOpen]);

  return { isOverlayOpen, toggleIsOverlayOpen, setIsOverlayOpen };
}
